/* eslint-disable */

import { createRouter, createWebHistory } from 'vue-router';
import HomePage from '@/components/HomePage.vue';
import AppAbout from '@/components/AppAbout.vue';
import AppContact from '@/components/AppContact.vue';
import AppServices from '@/components/App-services.vue';

import flooterOne from '@/components/flooter/flooterOne.vue'
import flooterTwo from '@/components/flooter/flooterTwo.vue'
import flooterThree from '@/components/flooter/flooterThree.vue'
import flooterFour from '@/components/flooter/flooterFour.vue'
import indiaLegends from '@/components/flooter/indiaLegends.vue'
const routes = [
  {
    path: '/',
    name: 'HomePage',
    component: HomePage
  },
  {
    path: '/about',
    name: 'AppAbout',
    component: AppAbout
  },
  {
    path: '/contact',
    name: 'AppContact',
    component: AppContact
  },
  {
    path: '/services',
    name: 'AppServices',
    component: AppServices
  },
  {
    path: '/flooterOne',
    name: 'flooterOne',
    component: flooterOne
  },
  {
    path: '/flooterTwo',
    name: 'flooterTwo',
    component: flooterTwo
  },
  {
    path: '/flooterThree',
    name: 'flooterThree',
    component: flooterThree
  },
  {
    path: '/flooterFour',
    name: 'flooterFour',
    component: flooterFour
  },
  {
    path: '/indiaLegends',
    name: 'indiaLegends',
    component: indiaLegends
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to, from, savedPosition) {
    // 无论是何种跳转方式，页面都会滚动到顶部
    return { top: 0,};//behavior: 'smooth',
  }
});

export default router;
